import TYPES from "./types";

interface State {
  topUrlParams: Record<string, string>;
}

export const state = (): State => ({
  topUrlParams: {}
});

export const mutations = {
  [TYPES.SET_TOP_URL_SEARCH](
    state: State,
    topUrlParams: Record<string, string>
  ) {
    state.topUrlParams = topUrlParams;
  }
};

export const actions = {};
